import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Dialog from '@/components/mui/Dialog';
import ROUTES_PATH from '@/router/routesPathConfig';
import { isPermissionsChangedSelector } from '@/domain/env';

const reloadOnCompanyList = () => window.location.assign(ROUTES_PATH.COMPANIES.absolute);

const DialogPermissionsChanged = () => {
  const isPermissionsChanged = useSelector(isPermissionsChangedSelector);

  return (
    <Dialog
      open={isPermissionsChanged}
      draggable={false}
      withActions={false}
      withContent={false}
      sx={{ zIndex: 'screenLock' }}
      title={<FormattedMessage id="app.permissionsChanged.title" defaultMessage="Your permissions have changed" />}
    >
      <DialogContent>
        <DialogContentText>
          <FormattedMessage
            id="app.permissionsChanged.body"
            defaultMessage="The system administrator updated your role/permissions. Reload the page to continue with your new access rights."
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={reloadOnCompanyList}>
          <FormattedMessage id="app.permissionsChanged.reload" defaultMessage="Reload" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogPermissionsChanged;
